<template>
  <img
    @click="emitOnClick"
    :alt="`${type} logo`"
    :src="url"
    class="logo"
    :style="
      `width: ${squared ? height : width}; height: ${
        squared ? height : height
      };`
    "
  />
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "veci",
      validate: ["veci" | "puntored" | "visa" | "pse" | "mastercard"]
    },
    squared: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "auto"
    },
    height: {
      type: String,
      default: "50px"
    }
  },
  methods: {
    emitOnClick(event) {
      this.$emit("click", event);
    }
  },
  computed: {
    url() {
      switch (this.type) {
        case "credit-card":
          return require("../assets/credit_card.png");
        case "veci":
          return require("../assets/veci.png");
        case "veci-white":
          return require("../assets/veci-white.png");
        case "puntored":
          return require("../assets/puntored.png");
        case "tiendacerca":
          return require("../assets/logo-vive.png");
        case "mastercard":
          return require("../assets/mastercard-horizontal.png");
        case "davivienda":
          return require("../assets/dvv-vertical.png");
        case "visa":
          return require("../assets/visa-logo.png");
        case "pse":
          return require("../assets/BotonPSE.png");
        case "fds":
          return require("../assets/fds.jpg");
        case "finky":
          return require("../assets/logo-finky.png");
        case "julaila":
          return require("../assets/logo-julaila.png");
        case "vigpro":
          return require("../assets/logo-vigpro.jpg");
        case "solidaridad":
          return require("../assets/logo-solidaridad.png");
        default:
          return require("../assets/veci.png");
      }
    }
  }
};
</script>
